/**
 * Axios options aligned with hire360-app main backend security:
 * HttpOnly session cookie (withCredentials) + x-portal + CSRF double-submit cookie.
 * Do not rely on reading JWT from JS; optional legacy Bearer only from localStorage if present.
 */

export function getCsrfTokenFromBrowser() {
  const match =
    document.cookie.match(/(?:^|; )hirecorrecto_csrf=([^;]*)/) ||
    document.cookie.match(/(?:^|; )csrfToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export function getMainBackendBaseHeaders() {
  const csrf = getCsrfTokenFromBrowser();
  return {
    "x-portal": "client",
    "ngrok-skip-browser-warning": true,
    ...(csrf ? { "x-csrf-token": csrf } : {}),
  };
}

/**
 * Authenticated browser session (HttpOnly cookie + CSRF + portal).
 * Use when `authorization` / `auth: true` or a logged-in HR user hits the main API.
 */
export function getMainBackendAxiosConfig() {
  return {
    headers: getMainBackendBaseHeaders(),
    withCredentials: true,
  };
}

/**
 * Anonymous public endpoints under `/public/assessment/*` — no session, no CSRF, no cookies.
 * Default for hire360-assessment when not using legacy Bearer.
 */
export function getPublicMainBackendAxiosConfig() {
  return {
    headers: {
      "ngrok-skip-browser-warning": true,
    },
  };
}

/** Legacy fallback only; prefer session cookie + CSRF. */
export function getLegacyBearerTokenFromStorage() {
  try {
    return localStorage.getItem("key");
  } catch {
    return null;
  }
}
